import React, { useState, useEffect } from "react";
import {
  Settings, Search, Users, Rocket, Building2, Calendar, Handshake, Megaphone,
  Check, Trash2, List, Clock, Ticket, Link2, Globe, MapPin, X
} from "lucide-react";
import Avatar from "./Avatar";
import { Loader } from "./UI";
import { generarInvitacion, getValidUrl } from "../utils/Utils";

export default function AdminPanel() {
  const [activeTab, setActiveTab] = useState("usuarios");
  const [activeSubTab, setActiveSubTab] = useState("todos"); // "todos" o "pendientes"
  const [isLoading, setIsLoading] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");

  // Estados para los datos
  const [usuarios, setUsuarios] = useState([]);
  const [proyectos, setProyectos] = useState([]);
  const [companias, setCompanias] = useState([]);
  const [eventos, setEventos] = useState([]);
  const [reuniones, setReuniones] = useState([]);
  const [anuncios, setAnuncios] = useState([]);

  // Función para obtener datos de la API
  const fetchData = async (endpoint) => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    console.log(endpoint);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/${endpoint}`, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
      const data = await response.json();
      console.log(data);
      return data;
    } catch (error) {
      console.error(`Error fetching ${endpoint}:`, error);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  // Función para obtener datos de la API
  const fetchProjects = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/project`, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(`Error fetching projects:`, error);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCompanias = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/company`, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(`Error fetching companies:`, error);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  // Cargar datos cuando cambie la pestaña activa
  useEffect(() => {
    const loadTabData = async () => {
      switch (activeTab) {
        case "usuarios":
          if (usuarios.length === 0) {
            const data = await fetchData("users");
            setUsuarios(data);
          }
          break;
        case "proyectos":
          if (proyectos.length === 0) {
            const data = await fetchProjects();
            setProyectos(data);
          }
          break;
        case "companias":
          if (companias.length === 0) {
            const data = await fetchCompanias();
            setCompanias(data);
          }
          break;
        case "eventos":
          if (eventos.length === 0) {
            const data = await fetchData("events");
            setEventos(data);
          }
          break;
        case "reuniones":
          if (reuniones.length === 0) {
            const data = await fetchData("meetings");
            setReuniones(data);
          }
          break;
        case "anuncios":
          if (anuncios.length === 0) {
            const data = await fetchData("announcements");
            setAnuncios(data);
          }
          break;
        default:
          break;
      }
    };

    loadTabData();
    // Resetear a "todos" cuando cambies de pestaña principal
    setActiveSubTab("todos");
  }, [activeTab]);

  // Función para aprobar elementos


  const handleApproveProject = async (itemId) => {
    if (!window.confirm(`¿Estás seguro de que quieres aprobar este proyecto?`)) {
      return;
    }
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/project/acceptProject/${itemId}`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ accepted: true })
      });

      if (response.ok) {
        alert("Proyecto aprobado correctamente");
        window.location.reload();
      } else {
        alert("Error al aprobar el proyecto");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error al aprobar el proyecto");
    }
  };

  const handleDeleteProject = async (itemId) => {
    if (!window.confirm(`¿Estás seguro de que quieres eliminar este proyecto?`)) {
      return;
    }
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/project/${itemId}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        alert("Proyecto eliminado correctamente");
        window.location.reload();
      } else {
        alert("Error al eliminar el proyecto");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error al aprobar el proyecto");
    }
  };

  const handleDeleteEvent = async (itemId) => {
    if (!window.confirm(`¿Estás seguro de que quieres eliminar este evento?`)) {
      return;
    }
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/events/${itemId}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        alert("Evento eliminado correctamente");
        window.location.reload();
      } else {
        alert("Error al eliminar el evento");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error al eliminar el evento");
    }
  };

  const handleDeleteReuniones = async (itemId) => {
    if (!window.confirm(`¿Estás seguro de que quieres eliminar esta reunión?`)) {
      return;
    }
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/meetings/${itemId}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        alert("Reunión eliminada correctamente");
        window.location.reload();
      } else {
        alert("Error al eliminar la reunión");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error al eliminar la reunión");
    }
  };

  const handleDeleteCompany = async (itemId) => {
    if (!window.confirm(`¿Estás seguro de que quieres eliminar esta compañía?`)) {
      return;
    }
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/company/${itemId}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        alert("Compañía eliminada correctamente");
        window.location.reload();
      } else {
        alert("Error al eliminar la compañía");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error al eliminar la compañía");
    }
  };

  const handleEdit = (item) => {
    console.log(item);

  };

  const handleDeleteAnuncio = async (itemId) => {
    if (!window.confirm(`¿Estás seguro de que quieres eliminar este anuncio?`)) {
      return;
    }
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/announcements/${itemId}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        alert("Anuncio eliminado correctamente");
        window.location.reload();
      } else {
        alert("Error al eliminar el anuncio");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error al eliminar el anuncio");
    }
  };


  const handleEditUser = async (item) => {
    setSelectedUser(item);
    setShowEditModal(true);
  };

  const closeModal = () => {
    setShowEditModal(false);
    setSelectedUser(null);
  };

  const EditUserModal = ({ user, onClose, onSave }) => {
    const [meetingAccepted, setMeetingAccepted] = useState(user.meetingAccepted);
    const [invitationsLeft, setInvitationsLeft] = useState(user.invitationsLeft);
    const [relevance, setRelevance] = useState(user.relevance ?? 0);

    const handleSubmit = (e) => {
      e.preventDefault();
      onSave({
        _id: user._id,
        meetingAccepted,
        invitationsLeft,
        relevance
      });
    };

    return (
      <div
        className="dyd-overlay"
        onClick={onClose}
      >
        <div
          className="dyd-modal"
          style={{ padding: 0, gap: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          <form onSubmit={handleSubmit}>
            {/* Header */}
            <div
              style={{
                padding: "16px 20px",
                borderBottom: "1px solid var(--dyd-border)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <h5 style={{ margin: 0, fontSize: "1.15rem", fontFamily: "'Sora', sans-serif", color: "#fff" }}>
                Editar usuario
              </h5>
              <button
                type="button"
                onClick={onClose}
                className="dyd-modal-close"
                aria-label="Cerrar"
              >
                <X size={20} />
              </button>
            </div>

            {/* Body */}
            <div style={{ padding: "20px" }}>
              {/* Invitaciones disponibles */}
              <div style={{ marginBottom: "16px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                    fontSize: "14px"
                  }}
                >
                  Invitaciones disponibles
                </label>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={invitationsLeft}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Solo permite números
                    if (value === '' || /^\d+$/.test(value)) {
                      setInvitationsLeft(value === '' ? 0 : Number(value));
                    }
                  }}
                  placeholder="Número de invitaciones"
                  required
                  className="dyd-input"
                />
              </div>

              {/* Relevance */}
              <div style={{ marginBottom: "16px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                    fontSize: "14px"
                  }}
                >
                  Relevancia
                </label>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={relevance}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === '' || /^\d+$/.test(value)) {
                      setRelevance(value === '' ? 0 : Number(value));
                    }
                  }}
                  placeholder="Relevancia del usuario"
                  required
                  className="dyd-input"
                />
              </div>

              {/* Meeting aceptado */}
              <div style={{ marginBottom: "16px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  <label
                    style={{
                      marginBottom: "0",
                      fontWeight: "500",
                      fontSize: "14px"
                    }}
                  >
                    Meeting aceptado
                  </label>
                  <input
                    type="checkbox"
                    checked={meetingAccepted}
                    onChange={(e) => setMeetingAccepted(e.target.checked)}
                    style={{
                      width: "20px",
                      height: "20px",
                      cursor: "pointer"
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Footer */}
            <div
              style={{
                padding: "16px 20px",
                borderTop: "1px solid var(--dyd-border)",
                display: "flex",
                justifyContent: "flex-end",
                gap: "8px"
              }}
            >
              <button
                type="button"
                onClick={onClose}
                className="dyd-btn dyd-btn-subtle"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="dyd-btn dyd-btn-primary"
              >
                Guardar cambios
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  // Función para eliminar elementos
  const handleDeleteUser = async (itemId, type) => {
    if (!window.confirm(`¿Estás seguro de que quieres eliminar este ${type}?`)) {
      return;
    }

    const token = localStorage.getItem("token");

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/users/${itemId}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        // Actualizar el estado local
        switch (type) {
          case "usuarios":
            setUsuarios(usuarios.filter(u => u._id !== itemId));
            break;
          case "proyectos":
            setProyectos(proyectos.filter(p => p._id !== itemId));
            break;
          case "companias":
            setCompanias(companias.filter(c => c._id !== itemId));
            break;
          case "eventos":
            setEventos(eventos.filter(e => e._id !== itemId));
            break;
          case "reuniones":
            setReuniones(reuniones.filter(r => r._id !== itemId));
            break;
          case "anuncios":
            setAnuncios(anuncios.filter(a => a._id !== itemId));
            break;
          default:
            break;
        }
        alert(`${type.charAt(0).toUpperCase() + type.slice(1)} eliminado correctamente`);
      } else {
        alert("Error al eliminar el elemento");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error al eliminar el elemento");
    }
  };

  const handleGenerateInvitation = async () => {
    const invitationCode = Math.random().toString(36).substring(2, 10).toUpperCase();
    const overlay = document.createElement("div");
    overlay.style.position = "fixed";
    overlay.style.inset = "0";
    overlay.style.backgroundColor = "rgba(4,6,10,0.78)";
    overlay.style.backdropFilter = "blur(7px)";
    overlay.style.display = "flex";
    overlay.style.justifyContent = "center";
    overlay.style.alignItems = "center";
    // Con hueco a los lados: en un móvil estrecho, sin él la ventana se sale
    overlay.style.padding = "16px";
    overlay.style.zIndex = "9999";

    const popup = document.createElement("div");
    popup.style.background = "linear-gradient(180deg, #131926, #0c1017)";
    popup.style.border = "1px solid rgba(255,255,255,0.18)";
    popup.style.color = "#e9edf5";
    popup.style.padding = "24px";
    popup.style.borderRadius = "12px";
    popup.style.boxShadow = "0 4px 12px rgba(0,0,0,0.25)";
    popup.style.width = "100%";
    popup.style.maxWidth = "340px";
    popup.style.textAlign = "center";

    const title = document.createElement("h3");
    title.innerText = "Tu código de invitación";
    title.style.marginBottom = "16px";
    popup.appendChild(title);

    const input = document.createElement("input");
    input.type = "text";
    input.value = invitationCode;
    input.readOnly = true;
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    input.style.padding = "10px";
    input.style.fontSize = "16px";
    input.style.borderRadius = "6px";
    input.style.border = "1px solid rgba(59,130,246,0.4)";
    input.style.background = "rgba(59,130,246,0.09)";
    input.style.color = "#fff";
    input.style.textAlign = "center";

    const copyBtn = document.createElement("button");
    copyBtn.innerText = "Copiar";
    copyBtn.style.marginTop = "16px";
    copyBtn.style.padding = "8px 16px";
    copyBtn.style.borderRadius = "6px";
    copyBtn.style.border = "none";
    copyBtn.style.background = "linear-gradient(135deg, #3b82f6, #1d4ed8)";
    copyBtn.style.color = "#fff";
    copyBtn.style.cursor = "pointer";

    copyBtn.onclick = () => {
      input.select();
      document.execCommand("copy");
      copyBtn.innerText = "¡Copiado!";
      setTimeout(() => {
        copyBtn.innerText = "Copiar";
        document.body.removeChild(overlay);
      }, 1000);
      window.location.reload();
    };

    try {
      await generarInvitacion(invitationCode);
    } catch (error) {
      console.error("Error al guardar los cambios:", error);
      alert("Error al guardar los cambios. Por favor, inténtalo de nuevo más tarde.");
    }

    popup.appendChild(input);
    popup.appendChild(copyBtn);
    overlay.appendChild(popup);
    document.body.appendChild(overlay);
    input.focus();
  };




  // Función para filtrar datos basado en el término de búsqueda y sub-pestaña
  const filterData = (data, searchFields) => {
    let filteredData = data;

    // Filtrar por sub-pestaña (solo para proyectos)
    if (activeTab === "proyectos") {
      if (activeSubTab === "pendientes") {
        filteredData = data.filter(item => item.accepted === false || item.accepted === undefined);
      } else {
        filteredData = data;
      }
    }

    // Filtrar por búsqueda
    if (searchTerm) {
      filteredData = filteredData.filter(item =>
        searchFields.some(field =>
          item[field]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    return filteredData;
  };

  // Función para obtener el conteo de elementos pendientes
  const getPendingCount = (data) => {
    return data.filter(item => item.accepted === false || item.accepted === undefined).length;
  };

  // Componente de tarjeta reutilizable
  const ItemCard = ({ item, type, onClick, onDelete, onApprove, isPending, children }) => (
    <div
      onClick={() => {
        onClick?.(item);
      }} // click en toda la tarjeta
      className={`dyd-item-card is-clickable ${isPending ? "is-flagged" : ""}`}
    >
      {children}

      {/* Botones de acción */}
      <div style={{ display: "flex", gap: "8px", marginTop: "10px", flexWrap: "wrap", position: "relative", zIndex: 1 }}>
        {isPending && (
          <>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onApprove(item._id, type);
              }}
              className="dyd-btn dyd-btn-success dyd-btn-sm"
            >
              <Check size={13} /> Aceptar
            </button>
          </>
        )}
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete(item._id, type);
          }}
          className="dyd-btn dyd-btn-danger dyd-btn-sm"
        >
          <Trash2 size={13} /> Eliminar
        </button>
      </div>
    </div>
  );

  return (
    <div className="dyd-page" style={{ display: "flex", justifyContent: "center" }}>
      <div style={{ width: "100%", maxWidth: "1200px", padding: "0 18px" }}>
        {/* Header */}
        <div className="dyd-rise" style={{ marginBottom: "30px" }}>
          <span className="dyd-eyebrow"><Settings size={13} /> Administración</span>
          <h1 style={{ marginTop: 16, marginBottom: 8 }}>
            Panel de <span className="dyd-gradient-text">control</span>
          </h1>
          <p className="dyd-lead" style={{ margin: 0 }}>
            Gestiona todos los aspectos de la plataforma desde aquí.
          </p>
        </div>

        {/* Barra de búsqueda */}
        <div className="dyd-admin-search">
          <Search size={16} />
          <input
            type="text"
            className="dyd-input"
            placeholder={`Buscar en ${activeTab}…`}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* Pestañas principales */}
        <div className="dyd-tabs dyd-tabs-wrap" style={{ marginBottom: "18px" }}>
          {[
            { key: "usuarios", label: "Usuarios", icon: Users },
            { key: "proyectos", label: "Proyectos", icon: Rocket },
            { key: "companias", label: "Compañías", icon: Building2 },
            { key: "eventos", label: "Eventos", icon: Calendar },
            { key: "reuniones", label: "Reuniones", icon: Handshake },
            { key: "anuncios", label: "Anuncios", icon: Megaphone }
          ].map(({ key, label, icon: Icon }) => (
            <button
              key={key}
              onClick={() => {
                setActiveTab(key);
                setSearchTerm("");
              }}
              className={`dyd-tab ${activeTab === key ? "active" : ""}`}
            >
              <Icon size={15} /> {label}
            </button>
          ))}
        </div>

        <button
          onClick={handleGenerateInvitation}
          className="dyd-btn dyd-btn-primary"
          style={{ marginBottom: "26px" }}
        >
          <Ticket size={16} /> Generar invitación
        </button>

        {/* Sub-pestañas (solo para proyectos) */}
        {activeTab === "proyectos" && (
          <div style={{ display: "flex", gap: "8px", marginBottom: "32px" }}>
            <button
              onClick={() => setActiveSubTab("todos")}
              className={`dyd-btn dyd-btn-sm ${activeSubTab === "todos" ? "dyd-btn-primary" : "dyd-btn-subtle"}`}
            >
              <List size={14} /> Todos ({proyectos.length})
            </button>
            <button
              onClick={() => setActiveSubTab("pendientes")}
              className={`dyd-btn dyd-btn-sm ${activeSubTab === "pendientes" ? "dyd-btn-primary" : "dyd-btn-subtle"}`}
              style={{ position: "relative" }}
            >
              <Clock size={14} /> Pendientes ({getPendingCount(proyectos)})
              {/* Badge de notificación */}
              {getPendingCount(proyectos) > 0 && (
                  <span
                    className="dyd-badge-dot"
                  >
                    !
                  </span>
                )}
            </button>
          </div>
        )}

        {/* Contenido por pestañas */}
        {isLoading && (
          <Loader text="Cargando" />
        )}

        {/* Usuarios */}
        {activeTab === "usuarios" && !isLoading && (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
              <h2 style={{ margin: 0 }}>Usuarios ({usuarios.length})</h2>
            </div>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 300px), 1fr))",
              gap: "16px"
            }}>
              {filterData(usuarios, ["name", "surname", "email"]).map(usuario => (
                <ItemCard
                  key={usuario._id}
                  item={usuario}
                  type="usuarios"
                  onClick={handleEditUser}
                  onDelete={handleDeleteUser}
                  isPending={false}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <Avatar
                      src={usuario.profilePicture}
                      name={usuario.name}
                      surname={usuario.surname}
                      size={50}
                    />
                    <div>
                      <span className="dyd-item-title">
                        {usuario.name} {usuario.surname}
                      </span>
                      <div className="dyd-meta">{usuario.email}</div>
                      <div style={{ color: "#007bff", fontSize: "12px" }}>
                        Invitaciones pendientes: {usuario.invitationsLeft || 0}
                      </div>
                    </div>
                  </div>
                </ItemCard>
              ))}
            </div>
          </div>
        )}

        {/* Proyectos */}
        {activeTab === "proyectos" && !isLoading && (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
              <h2 style={{ margin: 0 }}>
                Proyectos - {activeSubTab === "todos" ? "Todos" : "Pendientes de aprobación"}
                ({filterData(proyectos, ["name", "description"]).length})
              </h2>
            </div>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 300px), 1fr))",
              gap: "16px"
            }}>
              {filterData(proyectos, ["name", "description"]).map(proyecto => {
                const isPending = proyecto.accepted === false || proyecto.accepted === undefined;
                return (
                  <ItemCard
                    key={proyecto._id}
                    item={proyecto}
                    type="proyectos"
                    onEdit={handleEdit}
                    onDelete={handleDeleteProject}
                    onApprove={handleApproveProject}
                    isPending={isPending}
                  >
                    <span className="dyd-item-title">{proyecto.name}</span>
                    <span className="dyd-item-text">{proyecto.description}</span>
                    {proyecto.link && (
                      <a href={getValidUrl(proyecto.link)} target="_blank" rel="noopener noreferrer" className="dyd-item-link">
                        <Link2 size={12} /> {proyecto.link}
                      </a>
                    )}
                    <span className={`dyd-status ${proyecto.accepted === true ? "is-ok" : "is-wait"}`}>
                      {proyecto.accepted === true
                        ? <><Check size={12} /> Aceptado</>
                        : <><Clock size={12} /> Pendiente</>}
                    </span>
                  </ItemCard>
                );
              })}
            </div>
          </div>
        )}

        {/* Compañías */}
        {activeTab === "companias" && !isLoading && (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
              <h2 style={{ margin: 0 }}>
                Compañías
                ({filterData(companias, ["name", "category", "description"]).length})
              </h2>
            </div>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 300px), 1fr))",
              gap: "16px"
            }}>
              {filterData(companias, ["name", "category", "description"]).map(compania => {
                return (
                  <ItemCard
                    key={compania._id}
                    item={compania}
                    type="companias"
                    onEdit={handleEdit}
                    onDelete={handleDeleteCompany}
                    isPending={false}
                  >
                    <span className="dyd-item-title">
                      {compania.name}
                      <span style={{ fontWeight: 400, fontSize: "0.86rem", color: "var(--dyd-text-mute)", marginLeft: "8px" }}>
                        ({compania.category})
                      </span>
                    </span>
                    <span className="dyd-item-text">{compania.description}</span>
                    {compania.website && (
                      <a href={getValidUrl(compania.website)} target="_blank" rel="noopener noreferrer" className="dyd-item-link">
                        <Globe size={12} /> {compania.website}
                      </a>
                    )}
                  </ItemCard>
                );
              })}
            </div>
          </div>
        )}

        {/* Eventos */}
        {activeTab === "eventos" && !isLoading && (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
              <h2 style={{ margin: 0 }}>
                Eventos
                ({filterData(eventos, ["name", "description", "location", "category"]).length})
              </h2>
            </div>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 300px), 1fr))",
              gap: "16px"
            }}>
              {filterData(eventos, ["name", "description", "location", "category"]).map(evento => {
                return (
                  <ItemCard
                    key={evento._id}
                    item={evento}
                    type="eventos"
                    onEdit={handleEdit}
                    onDelete={handleDeleteEvent}
                    isPending={false}
                  >
                    <span className="dyd-item-title">{evento.name}</span>
                    <span className="dyd-item-text">{evento.description}</span>
                    {evento.date && (
                      <div className="dyd-item-link">
                        <Calendar size={14} /> {new Date(evento.date).toLocaleDateString('es-ES')}{evento.time && ` · ${evento.time}`}
                      </div>
                    )}
                    {evento.location && (
                      <div className="dyd-meta">
                        <MapPin size={14} /> {evento.location}
                      </div>
                    )}
                  </ItemCard>
                );
              })}
            </div>
          </div>
        )}

        {/* Reuniones */}
        {activeTab === "reuniones" && !isLoading && (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
              <h2 style={{ margin: 0 }}>
                Reuniones
                ({filterData(reuniones, ["name", "description", "category"]).length})
              </h2>
            </div>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 300px), 1fr))",
              gap: "16px"
            }}>
              {filterData(reuniones, ["name", "description", "category"]).map(reunion => {
                return (
                  <ItemCard
                    key={reunion._id}
                    item={reunion}
                    type="reuniones"
                    onEdit={handleEdit}
                    onDelete={handleDeleteReuniones}
                    isPending={false}
                  >
                    {/* El modelo Meeting usa name/date/time/category */}
                    <span className="dyd-item-title">{reunion.name}</span>
                    <span className="dyd-item-text">{reunion.description}</span>
                    {reunion.date && (
                      <div className="dyd-item-link">
                        <Clock size={14} /> {new Date(reunion.date).toLocaleDateString('es-ES')}{reunion.time && ` a las ${reunion.time}`}
                      </div>
                    )}
                    {reunion.category && (
                      <span className="dyd-chip">{reunion.category}</span>
                    )}
                  </ItemCard>
                );
              })}
            </div>
          </div>
        )}

        {/* anuncios */}
        {activeTab === "anuncios" && !isLoading && (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
              <h2 style={{ margin: 0 }}>
                Anuncios
                ({filterData(anuncios, ["title", "description", "type"]).length})
              </h2>
            </div>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 300px), 1fr))",
              gap: "16px"
            }}>
              {filterData(anuncios, ["title", "description", "type"]).map(anuncio => {
                return (
                  <ItemCard
                    key={anuncio._id}
                    item={anuncio}
                    type="anuncios"
                    onEdit={handleEdit}
                    onDelete={handleDeleteAnuncio}
                    isPending={false}
                  >
                    <span className="dyd-item-title">{anuncio.title}</span>
                    <span className="dyd-item-text">{anuncio.description}</span>
                  </ItemCard>
                );
              })}
            </div>
          </div>
        )}
        {showEditModal && selectedUser && (
          <EditUserModal
            user={selectedUser}
            onClose={closeModal}
            onSave={async (data) => {
              console.log("Datos a guardar:", data);
              try {
                const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/users/${data._id}`, {
                  method: "PUT",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    meetingAccepted: data.meetingAccepted,
                    invitationsLeft: data.invitationsLeft,
                    relevance: data.relevance
                  }),
                });
                const res = await response.json();
                if (!response.ok) {
                  alert("Error al guardar los cambios: " + res.message);
                }
              } catch (error) {
                console.error("Error al guardar los cambios:", error);
                alert("Error al guardar los cambios. Por favor, inténtalo de nuevo más tarde.");
              }
              closeModal();
              //Recargar la pagina
              window.location.reload();
            }}
          />
        )}
      </div>
    </div>
  );
}
